import {TuiContextWithImplicit, TuiIdentityMatcher} from '@taiga-ui/cdk';

export const isTuiContextWithImplicit = (
  value: any,
): value is TuiContextWithImplicit<{name: string; id: string}> => value.$implicit;

export const stringifyObject = (
  selected:
    | TuiContextWithImplicit<{name: string; id: string}>
    | {name: string; id: string},
): string =>
  isTuiContextWithImplicit(selected) ? selected.$implicit.name : selected.name;

export const identityMatcher: TuiIdentityMatcher<{name: string; id: string}> = (
  a: {name: string; id: string},
  b: {name: string; id: string},
) => a.id === b.id;
